"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var Theme_1 = require("../Theme");
exports.halfScreenUpperStyling = function (theme, width) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        height: 100%;\n        display: table-cell;\n        flex-direction: column;\n        justify-content: center;\n        width: ", "%;\n        order: 2;\n        @media (max-width: ", " )  {\n            width: 100%;\n            order: 0;\n        }\n    "], ["\n        height: 100%;\n        display: table-cell;\n        flex-direction: column;\n        justify-content: center;\n        width: ", "%;\n        order: 2;\n        @media (max-width: ", " )  {\n            width: 100%;\n            order: 0;\n        }\n    "])), width, Theme_1.applyTheme(theme, function (t) { return t.mobileWidth.minWidth; }));
};
exports.halfScreenLowerStyling = function (theme, width) {
    return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        height: 100%;\n        display: table-cell;\n        flex-direction: column;\n        justify-content: center;\n        width: ", "%;\n        @media (max-width: ", " )  {\n            width: 100%;\n        }\n    "], ["\n        height: 100%;\n        display: table-cell;\n        flex-direction: column;\n        justify-content: center;\n        width: ", "%;\n        @media (max-width: ", " )  {\n            width: 100%;\n        }\n    "])), width, Theme_1.applyTheme(theme, function (t) { return t.mobileWidth.minWidth; }));
};
exports.fullScreenStyling = function (theme) {
    return core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        margin-top: 100px;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n    "], ["\n        margin-top: 100px;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n    "])));
};
var ScreenSplit = /** @class */ (function (_super) {
    __extends(ScreenSplit, _super);
    function ScreenSplit(props) {
        return _super.call(this, props) || this;
    }
    ScreenSplit.prototype.render = function () {
        var _this = this;
        var leftRatio = 50;
        if (this.props.leftratio !== undefined) {
            leftRatio = this.props.leftratio * 100;
            if (leftRatio > 100) {
                leftRatio = 100;
            }
            else if (leftRatio < 0) {
                leftRatio = 0;
            }
            leftRatio = Math.round(leftRatio);
        }
        return (core_1.jsx("div", { css: function (t) { return [exports.fullScreenStyling(t), _this.props.outerStyle !== undefined ? _this.props.outerStyle(t) : undefined]; } },
            core_1.jsx("div", { css: function (t) { return _this.props.rightup ? exports.halfScreenUpperStyling(t, 100 - leftRatio) : exports.halfScreenLowerStyling(t, leftRatio); } }, this.props.rightup ? this.props.rightSide : this.props.leftSide),
            core_1.jsx("div", { css: function (t) { return !_this.props.rightup ? exports.halfScreenUpperStyling(t, 100 - leftRatio) : exports.halfScreenLowerStyling(t, leftRatio); } }, !this.props.rightup ? this.props.rightSide : this.props.leftSide)));
    };
    return ScreenSplit;
}(React.Component));
exports["default"] = ScreenSplit;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ScreenSplit.js.map